import { Reducer } from "redux";
import { CommonState, CommonActionTypes } from "./types";

 const initProjectSetting: any = {
  "browserIcon":"",
  "loginBrowserTitle": "E+系统-人力资源效率化作业平台",
  "loginSetting":{
    "loginBox": {
      "title": "欢迎使用E+管理平台"
    },
    "icpBox": {
        "copyrightLeft": "版权所有 2015",
        "copyrightRight": "viphrm.com Corporation. 保留一切权利.",
        "icp": "沪ICP备09067369号-4"
    },
    "leftBox": {
        "subTitle": "服务雇员一切需求",
        "logo": "https://cs-common.oss-cn-hangzhou.aliyuncs.com/e_page_logo_plain@2x.png",
        "title": "链接企业",
        "leftBoxBg":"https://preuploadv2.viphrm.com/filemanager/preview/?path=288572/202511/38a119baa5964c53bb29c1a547dd3ea3.png"
    },
    "registerBox": {
      "subTitle": "欢迎体验E+系统，人力资源效率化作业平台",
      "companyName":"上海微知数字科技有限公司",
      "eAdd":"E+"
    }
  }
};

// 初始化state
export const initCommonState: CommonState = {
  loading: {
    showA: false,
    showB: false,
    text: "",
    second: 0
  },
  projectSetting:{
    ...initProjectSetting
  }
};

const commonReducer: Reducer<CommonState> = (state = initCommonState, action) => {

  switch (action.type) {

    // 加载
    case CommonActionTypes.FETCH_LOADING: {
      return {
        ...state,
        loading: {
          ...state.loading,
          ...action.payload
        }
      }
    }

    // 更新单个state
    case CommonActionTypes.FETCH_UPDATE_COMMON_STATE: {
      return {
        ...state,
        ...action.payload
      }
    }
    
    default: {
      return {...state};
    }
  }
}

export { commonReducer }
